export const orgUser = {
  header: 'Tous les utilisateurs ({{count}})',
  disabled: '(désactivé)',
  uid: 'Courriel',
  active: 'Statut',
  name: 'Nom',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  email: 'Courriel',
  orgUnit: 'Unité',
  unit: 'Unité',
  roles: 'Rôles',
  rights: 'Droits',
  title: 'Titre',
  hint: 'Les utilisateurs sont les acheteurs, approbateurs, gestionnaires et administrateurs de votre organisation. Chaque utilisateur se voit assigner un rôle pour effectuer ou approuver des achats.',
  unitApprover: 'Approbateur de l\'unité',
  assignApprover: 'Ajouter l\'utilisateur aux approbateurs de l\'unité',
  actions: '',
  sortBy: 'Trier par',
  sort: {
    byName: 'Nom',
    byUnit: 'Unité',
  },
  details: {
    title: 'Détails de l\'utilisateur',
    subtitle: 'Utilisateur : {{ item.name }}',
  },
  edit: {
    title: 'Modifier l\'utilisateur',
    subtitle: 'Utilisateur : {{ item.name }}',
  },
  create: {
    title: 'Créer un utilisateur',
    subtitle: '',
  },
  links: {
    password: 'Modifier le mot de passe',
    approvers: 'Approbateurs',
    userGroup: 'Groupes d\'utilisateurs',
    permission: 'Limites d\'achat',
    rolesAndRights: 'Rôles et droits',
  },
  messages: {
    deactivateTitle: 'Désactiver cet utilisateur?',
    deactivate: 'Les utilisateurs désactivés ne peuvent pas se connecter à la vitrine et passer des commandes.',
    confirmEnabled: 'Utilisateur {{item.firstName}} {{item.lastName}} activé avec succès',
    confirmDisabled: 'Utilisateur {{item.firstName}} {{item.lastName}} désactivé avec succès',
    update: 'Utilisateur {{item.firstName}} {{item.lastName}} mis à jour avec succès',
    create: 'Utilisateur {{item.firstName}} {{item.lastName}} créé avec succès',
    updatePassword: 'Mot de passe de l\'utilisateur {{item.firstName}} {{item.lastName}} mis à jour avec succès',
  },
  info: {
    disabledEdit: 'Activez l\'utilisateur pour permettre la modification.',
    disabledEnable: 'L\'unité doit être activée avant que cet utilisateur puisse être activé.',
  },
  approver: {
    link: 'Approbateurs',
    header: 'Approbateurs dans {{code}}',
    assign: 'Assigner des approbateurs',
    assignHeader: 'Assigner des approbateurs dans {{code}}',
    back: 'Retour',
    new: 'Nouvel approbateur',
    instructions: {
      check: 'Pour assigner un approbateur à cet utilisateur, cochez la case de l\'utilisateur.',
      uncheck: 'Pour supprimer un approbateur, décochez la case de l\'utilisateur.',
      changes: 'Les modifications sont sauvegardées automatiquement.',
    },
  },
  userGroup: {
    link: 'Groupes d\'utilisateurs',
    header: 'Groupes d\'utilisateurs dans {{code}}',
    assign: 'Assigner des groupes d\'utilisateurs',
    assignHeader: 'Assigner des groupes d\'utilisateurs dans {{code}}',
    back: 'Retour',
    instructions: {
      check: 'Pour assigner un groupe d\'utilisateurs à cet utilisateur, cochez la case de l\'utilisateur.',
      uncheck: 'Pour supprimer un groupe d\'utilisateurs, décochez la case de l\'utilisateur.',
      changes: 'Les modifications sont sauvegardées automatiquement.',
    },
  },
  permission: {
    link: 'Limites d\'achat',
    header: 'Limites d\'achat dans {{code}}',
    assign: 'Assigner des limites d\'achat',
    assignHeader: 'Assigner des limites d\'achat dans {{code}}',
    back: 'Retour',
    instructions: {
      check: 'Pour assigner une limite d\'achat à cet utilisateur, cochez sa case.',
      uncheck: 'Pour désassigner une limite d\'achat, décochez sa case.',
      changes: 'Les modifications sont sauvegardées automatiquement.',
    },
    per: {
      undefined: '',
      MONTH: 'par mois',
      YEAR: 'par année',
      WEEK: 'par semaine',
      QUARTER: 'par trimestre',
    },
  },
  password: {
    title: 'Modifier le mot de passe',
    subtitle: 'Utilisateur : {{ item.email }}',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
  },
  breadcrumbs: {
    list: 'Tous les utilisateurs',
    details: '{{name}}',
    userGroups: 'Groupes d\'utilisateurs',
    approvers: 'Approbateurs',
    permissions: 'Limites d\'achat',
  },
};

export const orgUserAssignedApprovers = {
  title: 'Approbateurs assignés',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Approbateur {{ item.name }} assigné avec succès',
  unassigned: 'Approbateur {{ item.name }} désassigné avec succès',
};
export const orgUserApprovers = {
  title: 'Gérer les approbateurs',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Approbateur {{ item.name }} assigné avec succès',
  unassigned: 'Approbateur {{ item.name }} désassigné avec succès',
};

export const orgUserAssignedPermissions = {
  title: 'Limites d\'achat assignées',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Limite d\'achat {{ item.code }} assignée avec succès',
  unassigned: 'Limite d\'achat {{ item.code }} désassignée avec succès',
};

export const orgUserPermissions = {
  title: 'Gérer les limites d\'achat',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Limite d\'achat {{ item.code }} assignée avec succès',
  unassigned: 'Limite d\'achat {{ item.code }} désassignée avec succès',
};

export const orgUserAssignedUserGroups = {
  title: 'Groupes d\'utilisateurs assignés',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Groupe d\'utilisateurs {{item.name}} assigné avec succès',
  unassigned: 'Groupe d\'utilisateurs {{item.name}} désassigné avec succès',
};

export const orgUserUserGroups = {
  title: 'Gérer les groupes d\'utilisateurs',
  subtitle: 'Utilisateur : {{ item.name }}',
  assigned: 'Groupe d\'utilisateurs {{item.name}} assigné avec succès',
  unassigned: 'Groupe d\'utilisateurs {{item.name}} désassigné avec succès',
};
